import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';


@Component({
  selector: 'app-local-table',
  templateUrl: './local-table.component.html',
  styleUrls: ['./local-table.component.scss']
})
export class LocalTableComponent implements OnInit {

  @Input() columns: string[] = [];
  @Input() displayColumns: string[] = [];
  @Input() dataSource: any[] = [];
  @Input() dataRequest: Observable<any>;
  @Output() deletedRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() editedRow: EventEmitter<any> = new EventEmitter<any>();
  @Output() openedRow: EventEmitter<any> = new EventEmitter<any>();
  startIndex: number;
  endIndex: number;
  providedData = false;


  constructor() {
  }

  ngOnInit(): void {
    if (!this.dataSource){
      this.dataRequest.subscribe(request => {
        if (request) {
          this.dataSource = request.data?.items;
          this.providedData = true;
        }
      });
    }
    this.providedData = this.dataSource !== undefined;
  }

  // emits indexes to slice the datasource
  onChangePage(indexes: any) {
    this.startIndex = indexes[0];
    this.endIndex = indexes[1];
  }

  editRow(event: any) {
    this.editedRow.emit(event);
  }

  deleteRow(event: any) {
    this.dataSource.splice(this.dataSource.indexOf(event), 1);
    this.dataSource = this.dataSource.splice(0);
    this.deletedRow.emit(event);
  }

  openRow(row) {
    this.openedRow.emit(row);
  }
}
